import useHttpStatus from './useHttpStatus';

export default (opts) => {
  const [res, req, fetched, progress] = useHttpStatus({
    progress: true,
    ...opts,
  });

  const onFile = (api = {}, file) => {
    const fd = new FormData();

    fd.append('file', file);

    if (process.env.NODE_ENV !== 'production') {
      console.log('[useFileUpload] upload start', {
        url: api.url,
        name: file && file.name,
        size: file && file.size,
        type: file && file.type,
      });
    }

    return req({
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: fd,
      ...api,
    });
  };

  return [res, onFile, fetched, progress];
};
